const Constraints = () => ({
  video: {
    deviceId: null,
    width: {
      exact: null
    },
    height: {
      exact: null
    },
    frameRate: {
      exact: null
    }
  },
  audio: {
    deviceId: null,
    autoGainControl: false,
    echoCancellation: false,
    noiseSuppression: false
  }
})

export default Constraints
